module.exports = __webpack_public_path__ + "static/profile-asking-3550d81801fe426262395f94e841a475.png";